import { useEffect, useState, useCallback } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import Layout from "../../../Layout";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import Swal from "sweetalert2";
import DeletePop from "../../../constants/ErrorPermissionModal";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import SearchField from "../../../components/SearchField";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { message } from "antd";
import SwitchBar from "../../../components/Pages/SwitchBar";
import ActiveStatusSwitch from "../../../components/MobileNotification/ActiveStatusSwitch";
import ValidDateEditor from "../../../components/MobileNotification/ValidDateEditor";

import Logs from "../../../components/Logs";
import { addlog } from "../../../utils/ApiCalls/Logs";
import {
  getNotifications,
  deleteNotification,
  handleStatus,
  handleValidity,
} from "../../../utils/ApiCalls/Mobile/Notification/index";
import { useMemo } from "react";
import { convertTo12Hour } from "../../../constants/getTimeDate";
import { getSailingData } from "../../../utils/ApiCalls/Mobile/Notification";
import { LOG_ACTIONS, LOG_TYPES } from "../../../utils/Constant/LogConstant";
import moment from "moment";

export const MobileNotificationInput = () => {
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const params = useParams();
  const [active, setActive] = useState("listing");
  const [vesselOptions, setVesselOptions] = useState([]);
  const [rows, setRows] = useState([]);
  // const [columns, setColumns] = useState([]);
  const [sailingData, setSailingData] = useState([]);
  const [count, setCount] = useState(10);

  const navigate = useNavigate();
  const location = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(location.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(location.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(location.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    setPage(pageParam);
    setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(location.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, location.search]);

  const handleEdit = async (id) => {
    if (
      checkPermission(
        permission,
        "update_per",
        "Notifications",
        window?.location?.pathname
      )
    ) {
      navigate(`/shore/notifications/edit/${id}${window.location.search}`);
    } else {
      message.error("Update permission missing");
    }
  };

  const handleActiveStatus = async (id, title,record) => {
    if (
      checkPermission(
        permission,
        "update_per",
        "Notifications",
        window?.location?.pathname
      )
    ) {
      const res = await handleStatus(id);
      if (res.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.error,
        });
      } else {
        setRows((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, isActive: item.isActive ? 0 : 1 } : item
          )
        );
         addlog(
           record.isActive ===  1 ? LOG_ACTIONS.DEACTIVATED : LOG_ACTIONS.ACTIVATED,
          "Notifications",
          { id, title: `${record.title} Notification`  },
          userDetails.id
        );
        message.success("Status updated successfully");
      }
    } else {
      message.error("Missing permission for status update");
    }
  };

  const handleDateValidity = async (id, title, data) => {
    if (
      checkPermission(
        permission,
        "update_per",
        "Notifications",
        window?.location?.pathname
      )
    ) {
      const res = await handleValidity(id, data);
      if (res.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.error,
        });
      } else {
        setRows((prev) =>
          prev.map((item) =>
            item.id === id
              ? { ...item, valid_from: data.validFrom, valid_to: data.validTo }
              : item
          )
        );
        addlog(
          LOG_ACTIONS.UPDATED,
          "Notifications",
          { id, title: `${title}-Notification Valid Date from ${moment(data.validFrom).format("YYYY-MM-DD hh:mm:ss")} to ${moment(data.validTo).format("YYYY-MM-DD hh:mm:ss")}` },
          userDetails.id
        );
        message.success("Status updated successfully");
      }
    } else {
      message.error("Missing permission for status update");
    }
  };

  const handleDelete = async (id, title) => {
    if (
      checkPermission(
        permission,
        "delete_per",
        "Notifications",
        window?.location?.pathname
      )
    ) {
      let val = await deleteNotification(id);
      if (val.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: val.error,
        });
      } else {
        // await getData({ page });
        // update rows immediately instead of fetching
        setRows((prev) => prev.filter((item) => item.id !== id));
        setCount((prev) => prev - 1);
        addlog(
          LOG_ACTIONS.REMOVED,
          LOG_TYPES.NOTIFICATIONS,
          { id, title: `${title} Notification` ,values: val.data },
          userDetails.id
        );
      }
    } else {
      message.error("Missing Permission for delete");
    }
  };

  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Notification",
      route: "/shore/mobile-masters/activity-categories",
    },
  ];

  const getData = async (value) => {
    let data = await getNotifications({
      page: value,
      limit: pageSize,
      search,
    });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };

  useEffect(() => {
    const getSailingDataAsync = async () => {
      dispatch({ type: "SET_LOADING", loading: true });

      try {
        const fetchedSailingData = await getSailingData();

        if (fetchedSailingData?.error) {
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: fetchedSailingData.error, type: "error" },
          });
        } else {
          setSailingData(fetchedSailingData.data);
        }
      } catch (err) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: err.message ?? "Unknown error", type: "error" },
        });
      } finally {
        dispatch({ type: "SET_LOADING", loading: false });
      }
    };

    getSailingDataAsync();
  }, []);

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
            ? "desc"
            : undefined;
      await getData(page, sort, order);
    }
  };

  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: "Sl",
        width: 10,
        dataIndex: "id",
        key: "id",
        fixed: "left",
        render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Title",
        width: 200,
        dataIndex: "title",
        key: "title",
        fixed: "left",
        render: (item) => <div dangerouslySetInnerHTML={{ __html: item }} />,
      },
      {
        title: "Type",
        width: 20,
        dataIndex: "categoryType",
        key: "categoryType",
        render: (value) => (
          <span>
            {value ? value.charAt(0).toUpperCase() + value.slice(1) : ""}
          </span>
        ),
      },
      {
        title: "Status",
        width: 220,
        dataIndex: "status",
        key: "status",
        render: (_, record) => (
          <span>
            {record.isScheduled
              ? `Scheduled for: ${record.notificationDate || ""} ${convertTo12Hour(record.notificationTime) || ""
              }`
              : `Sent At: ${record.notificationDate || ""} ${convertTo12Hour(record.notificationTime) || ""
              }`}
          </span>
        ),
      },
      {
        title: "Valid Date",
        dataIndex: "valid_date",
        key: "valid_date",
        width: 200,
        render: (text, record, index) => {
          return (
            <ValidDateEditor
              record={record}
              handleUpdate={handleDateValidity}
            />
          );
        },
      },
      {
        title: "Active",
        dataIndex: "isActive",
        key: "isActive",
        width: 30,
        // sorter: (a, b) => "",
        render: (_, record) => (
          <ActiveStatusSwitch
            record={record}
            handleActiveStatus={handleActiveStatus}
          />
        ),
      },
      {
        title: "Actions",
        key: "operation",
        width: 50,
        render: (text, record) => (
          <div className="table_action_btn">
            <button className="btn" onClick={() => handleEdit(record.id)}>
              <i
                className={
                  record.isScheduled === 0 ? "ri-eye-line" : "ri-edit-2-line"
                }
                data-toggle="tooltip"
                title={record.isScheduled === 0 ? "View" : "Edit"}
              ></i>
            </button>
            <DeletePop onConfirm={() => handleDelete(record.id, record.title,record)}>
              <div>
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
    ];

    // Conditionally add Target Ship & Sailing
    if (sailingData?.length > 0) {
      baseColumns.splice(2, 0, {
        title: "Target Ship & Sailing",
        dataIndex: "sailingDate",
        key: "sailingDate",
        width: 180,
        render: (_, record) => (
          <div>
            {record.sailingDate && (
              <span>
                {new Date(record.sailingDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            )}
          </div>
        ),
      });
    }

    return baseColumns;
  }, [page, pageSize, sailingData]);

  useEffect(() => {
    getData(page);
  }, [page, pageSize, search]);

  // Define styles for better maintainability
  const containerStyle = {
    display: "flex",
    padding: ".75rem 1.25rem",
    justifyContent: "space-between",
  };

  const searchContainerStyle = {
    maxWidth: 200,
  };

  // Memoized handlers for performance optimization
  const handleSearchValue = useCallback(() => {
    setPage(page); // Assuming this is intended; consider resetting to 1 if needed
  }, [page]);

  const handleSetValue = (e) => {
    setSearch(e.target.value);
  };

  // console.log({
  //   params,
  //   vesselOptions,
  //   vesselId,
  //   page,
  //   rows,
  //   pageSize,
  //   search,
  // });

  return (
    <Layout type={"read_per"} module_data={"Notifications"}>
      <CustomHeaderTitle
        title={
          "Notifications " +
          vesselOptions.find(
            (item) =>
              item.name.toLowerCase().replaceAll(" ", "-") === params?.vessel
          )?.name
        }
      />

      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Manage Notifications"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Notifications List", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active == "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Notification List</h5>

                  <div className="two_item">
                    <Link
                      to={`/shore/notifications/add${location.search}`}
                      className="btn add_v_btn mx-2"
                    >
                      Add Notifications
                    </Link>
                  </div>
                </div>
                <div style={containerStyle}>
                  <div></div>
                  <div className="mx-2"  style={searchContainerStyle}>
                    <SearchField
                      value={search}
                      SearchValue={handleSearchValue}
                      setValue={handleSetValue}
                      style={{ width: "100%" , maxWidth: "200px" ,marginBottom: 0}}
                    />
                  </div>
                </div>
                {rows && columns && (
                  <CustomizedTable
                    setRows={setRows}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    pageSize={pageSize}
                    page={page}
                    count={count}
                    columns={columns}
                    rows={rows}
                    title={"Notification Page"}
                    sortHandler={sortHandler}
                    tableStyle={{ marginBottom: 0 }}
                  />
                )}
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs type={"Notifications"} slug={"/shore/notifications/edit/"} />
        )}
      </div>
    </Layout>
  );
};

export default MobileNotificationInput;
